import React from "react";

const formatDateSeparator = (timestamp) => {
  const messageDate = new Date(timestamp);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // Reset hours to compare just the dates
  const messageDay = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());
  const todayDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const yesterdayDay = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());

  if (messageDay.getTime() === todayDay.getTime()) {
    return "Today";
  } else if (messageDay.getTime() === yesterdayDay.getTime()) {
    return "Yesterday";
  } else {
    return messageDate.toLocaleDateString([], {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  }
};

export default function DateSeparator({ timestamp }) {
  return (
    <div className="text-center my-2">
      <span className="badge bg-secondary" style={{ fontSize: "0.85rem", opacity: 0.85 }}>
        {formatDateSeparator(timestamp)}
      </span>
    </div>
  );
}
